import type { ReactNode } from "react";
import Image from "next/image";

import { useTranslation } from "@flare/i18n";
import { Card, CardPreview, Heading, Icon } from "@flare/ui/components";

export function CostCalculatorSection({
  children,
  title,
  className,
  isFilled,
  imageSrc,
}: {
  children: ReactNode;
  className?: string;
  imageSrc?: string;
  isFilled?: boolean;
  title?: string;
}) {
  const { t } = useTranslation();

  return (
    <Card className={className}>
      {title && (
        <CardPreview className="flex items-center justify-between border-b border-primary px-sp-4 py-sp-3">
          <div className="flex items-center">
            {imageSrc && (
              <div className="mr-sp-1">
                <Image
                  src={imageSrc}
                  width={48}
                  height={48}
                  alt={t("COST_CALCULATOR_SECTION_IMAGE_ALT")}
                />
              </div>
            )}
            <Heading variant="h4">{title}</Heading>
          </div>
          {isFilled && (
            <Icon name="check-circle-filled" color="action" size="lg" />
          )}
        </CardPreview>
      )}
      <div className="flex flex-row pt-sp-6">{children}</div>
    </Card>
  );
}
